import React from 'react';
import { Link } from 'react-router-dom';
import FacebookFeedMockup from './FacebookFeedMockup';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Facebook Se-vores-arbejde sektion før Footer (Motorsport / Vandrette Striber & Nedtonet Livery Stil) */}
      <section aria-label="Følg Cre8it på Facebook" className="relative overflow-hidden bg-[#2d5c51] pt-12 sm:pt-16 lg:pt-20 pb-0 text-white">
        
        {/* Brand Grøn Top-Stribe med glidende overgang */}
        <div className="absolute top-0 left-0 right-0 h-1.5 z-30 bg-[linear-gradient(to_right,#deecd4_0%,#245b53_40%,#12302c_75%,transparent_100%)] shadow-[0_0_12px_rgba(36,91,83,0.35)]" />

        {/* Vandrette Racing-Striber og Geometri i baggrunden - ryddet op og nedtonet i højre side */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden select-none">
          {/* Subtil dyb grøn ambient glød bag mobilen i venstre side */}
          <div className="absolute bottom-6 left-12 w-80 h-80 bg-[#245b53]/25 rounded-full blur-3xl" />
        </div>

        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-end">
            
            {/* Mobil Mockup med Facebook feed - skåret af i bunden */}
            <div className="lg:col-span-6 xl:col-span-5 flex justify-start items-end -mb-16 sm:-mb-20 lg:-mb-24 order-2 lg:order-1">
              <div className="relative w-[290px] sm:w-[325px] shadow-[0_25px_60px_rgba(0,0,0,0.85)] rounded-[2.5rem] border-[8px] border-[#141816] bg-[#090c0b] ring-1 ring-[#245b53]/50">
                {/* Højttaler / Dynamic Island øverst */}
                <div className="absolute top-2 left-1/2 -translate-x-1/2 z-20 flex items-center justify-center pointer-events-none">
                  <div className="h-3.5 w-20 bg-zinc-800 rounded-full flex items-center justify-center gap-1.5 px-2">
                    <span className="h-1.5 w-1.5 rounded-full bg-zinc-950"></span>
                    <span className="h-1 w-6 rounded-full bg-zinc-700"></span>
                  </div>
                </div>

                {/* Mobilskærm med det fulde live Facebook Feed */}
                <FacebookFeedMockup />

                {/* Hjem-knap indikator */}
                <div className="absolute bottom-2 left-1/2 -translate-x-1/2 h-1 w-24 bg-white/30 rounded-full pointer-events-none"></div>
              </div>
            </div>

            {/* Højre side: Nedtonet & Stilren typografi med vandrette racing linjer */}
            <div className="lg:col-span-6 xl:col-span-7 flex flex-col justify-center space-y-6 text-left pb-10 sm:pb-14 lg:pb-20 order-1 lg:order-2">
              
              {/* Badge */}
              <div className="flex items-center gap-3">
                <div className="inline-flex items-center gap-2 bg-[#245b53]/25 border border-[#245b53]/60 px-3.5 py-1 text-xs font-semibold tracking-wider text-[#deecd4] uppercase rounded-full shadow-[0_0_12px_rgba(36,91,83,0.25)]">
                  <i className="fa-brands fa-facebook text-[#deecd4]" />
                  <span>Følg os på Facebook</span>
                </div>
              </div>

              {/* Overskrift */}
              <div className="space-y-3">
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white leading-tight">
                  Se vores seneste <span className="text-[#deecd4]">projekter</span> & opdateringer
                </h2>

                <p className="text-sm sm:text-base text-gray-300 leading-relaxed max-w-xl">
                  Følg Cre8it på Facebook, hvor vi jævnligt deler billeder af monteret solfilm, bildekorationer, skilte og nyheder direkte fra værkstedet.
                </p>
              </div>

              {/* Handlingsknap med brand styling */}
              <div className="pt-2 space-y-2.5">
                <div className="flex flex-wrap items-center gap-4">
                  <a
                    href="https://www.facebook.com/people/Cre8it/61557070354740/?locale=da_DK"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="relative group inline-flex items-center justify-center px-7 py-3.5 text-sm font-bold uppercase tracking-wider text-gray-950 transition-all duration-200 rounded-lg bg-white hover:bg-[#deecd4] hover:text-[#245b53] active:scale-95 shadow-[0_10px_25px_rgba(0,0,0,0.4)] hover:shadow-[0_0_25px_rgba(36,91,83,0.3)] cursor-pointer"
                  >
                    <span className="inline-flex items-center gap-2.5">
                      <i className="fa-brands fa-facebook-f text-base text-[#1877F2] group-hover:text-[#245b53] transition-colors" />
                      <span>Besøg Cre8it på Facebook</span>
                      <i className="fa-solid fa-arrow-right text-xs group-hover:translate-x-1 transition-transform" />
                    </span>
                  </a>
                </div>

                <p className="text-xs text-gray-400">
                  Åbner Cre8it på Facebook i et nyt vindue med billeder, anmeldelser og opslag.
                </p>
              </div>

            </div>

          </div>
        </div>
      </section>

      <footer className="border-t border-gray-800 bg-gray-950 text-gray-300">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          
          {/* Sektion 1: Om virksomheden & Logo */}
          <div className="space-y-4">
            <img 
              src="https://assets.auxodev.dk/assets/83c5e513-aae5-4fee-8b74-db63d3cee346/chatgpt-image-18-2-3-2026-3-15-37-20.png"
              alt="CRE8IT Logo" 
              className="h-14 sm:h-16 w-auto object-contain"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Professionel montering af solfilm til biler, maskiner og bygninger, bildekoration, skiltning og interiørfolie. Over 15 års erfaring med kvalitet i højsædet.
            </p>
            <div className="flex items-center gap-3 pt-2">
              <a
                href="https://www.facebook.com/people/Cre8it/61557070354740/?locale=da_DK"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Følg os på Facebook"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-gray-900 text-gray-400 hover:bg-brand-red hover:text-white transition-colors"
              >
                <i className="fa-brands fa-facebook-f text-sm" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Følg os på Instagram"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-gray-900 text-gray-400 hover:bg-brand-red hover:text-white transition-colors"
              >
                <i className="fa-brands fa-instagram text-sm" />
              </a>
            </div>
          </div>

          {/* Sektion 2: Ydelser & Dropdowns */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Ydelser
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/solfilm/bil" className="text-gray-400 hover:text-white transition-colors">
                  Solfilm til bil
                </Link>
              </li>
              <li>
                <Link to="/solfilm/maskin" className="text-gray-400 hover:text-white transition-colors">
                  Solfilm til maskiner & traktorer
                </Link>
              </li>
              <li>
                <Link to="/solfilm/hus" className="text-gray-400 hover:text-white transition-colors">
                  Solfilm til hus & erhverv
                </Link>
              </li>
              <li>
                <Link to="/dekoration/bil" className="text-gray-400 hover:text-white transition-colors">
                  Bildekoration
                </Link>
              </li>
              <li>
                <Link to="/dekoration/lastbil" className="text-gray-400 hover:text-white transition-colors">
                  Lastbildekoration
                </Link>
              </li>
              <li>
                <Link to="/dekoration/vaeg" className="text-gray-400 hover:text-white transition-colors">
                  Vægfolie & print
                </Link>
              </li>
              <li>
                <Link to="/interioerfolie" className="text-gray-400 hover:text-white transition-colors">
                  Interiørfolie til køkken & møbler
                </Link>
              </li>
              <li>
                <Link to="/logodesign" className="text-gray-400 hover:text-white transition-colors">
                  Logodesign & grafik
                </Link>
              </li>
            </ul>
          </div>

          {/* Sektion 3: Hurtige Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Navigation
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/solfilm/bil" className="text-gray-400 hover:text-white transition-colors">
                  Solfilm
                </Link>
              </li>
              <li>
                <Link to="/dekoration/bil" className="text-gray-400 hover:text-white transition-colors">
                  Dekoration
                </Link>
              </li>
              <li>
                <Link to="/interioerfolie" className="text-gray-400 hover:text-white transition-colors">
                  Interiør folie
                </Link>
              </li>
              <li>
                <Link to="/logodesign" className="text-gray-400 hover:text-white transition-colors">
                  Logodesign
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-400 hover:text-white transition-colors">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Sektion 4: Kontaktoplysninger */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Kontakt
            </h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot mt-1 text-brand-red" />
                <span>
                  Cre8it<br />
                  6630 Rødding
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-brand-red" />
                <a href="tel:70604788" className="hover:text-white transition-colors whitespace-nowrap">
                  70 60 47 88
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-brand-red" />
                <a href="mailto:kontor@cre8it.nu" className="hover:text-white transition-colors">
                  kontor@cre8it.nu
                </a>
              </li>
              <li className="flex items-center gap-3 text-xs text-gray-500 pt-1">
                <span>CVR: 44682656</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bundlinje & Copyright */}
        <div className="mt-12 border-t border-gray-900 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-400">
          <p>© {currentYear} Cre8it. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-6">
            <Link to="/kontakt" className="hover:text-gray-300 transition-colors">
              Privatlivspolitik
            </Link>
            <Link to="/kontakt" className="hover:text-gray-300 transition-colors">
              Handelsbetingelser
            </Link>
          </div>
        </div>
      </div>
    </footer>
  </>
  );
}
